import { FormSchema } from "../../../components/dynamicform/DynamicFormTypes";

const YYYY_MM_DD_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

export const registrationForm: FormSchema = {
    title: "Registration",
    fields: [
        {
            name: "doiUrl",
            type: "url",
            label: "DOI URL",
            defaultValue: "",
            validationRules: {
                validate: {
                    maxLength: (v: string) => v.trim().length <= 255 || "URL field cannot exceed 255 characters",
                }
            }
        },
        {
            name: "title",
            type: "text",
            label: "Title",
            defaultValue: "",
            validationRules: {
                validate: {
                    atLeastOne: (v: string) => v.trim().length > 0 || "Title field can not be empty",
                    maxLength: (v: string) => v.trim().length <= 600 || "Title field cannot exceed 600 characters",
                }
            }
        },
        {
            name: "purpose",
            type: "textarea",
            rows: 5,
            label: "Purpose",
            defaultValue: "",
            validationRules: {
                validate: {
                    atLeastOne: (v: string) => v.trim().length > 0 || "Purpose field can not be empty",
                    maxLength: (v: string) => v.trim().length <= 1200 || "Purpose field cannot exceed 1200 characters",
                }
            }
        },
        {
            name: "method",
            type: "textarea",
            rows: 5,
            label: "Method",
            defaultValue: "",
            placeholder: "",
            validationRules: {
                validate: {
                    maxLength: (v: string) => v.trim().length <= 1200 || "Method field cannot exceed 1200 characters",
                }
            }
        },
        {
            name: "results",
            type: "textarea",
            rows: 5,
            label: "Results",
            defaultValue: "",
            placeholder: "",
            validationRules: {
                validate: {
                    maxLength: (v: string) => v.trim().length <= 1200 || "Results field cannot exceed 1200 characters",
                }
            }
        },
        {
            name: "conclusion",
            type: "textarea",
            rows: 5,
            label: "Conclusion",
            defaultValue: "",
            placeholder: "",
            validationRules: {
                validate: {
                    maxLength: (v: string) => v.trim().length <= 1200 || "Conclusion field cannot exceed 1200 characters",
                }
            }
        },
        {
            name: "datePublished",
            type: "text",
            label: "Date",
            defaultValue: "",
            placeholder: "YYYY-MM-DD",
            validationRules: {
                validate: {
                    maxLength: (v: string) => v.trim().length <= 10 || "Date field cannot exceed 10 characters",
                    dateFormat: (v: string) => v.trim().length === 0 || YYYY_MM_DD_REGEX.test(v.trim()) || "Date must use YYYY-MM-DD format",
                }
            }
        },
        {
            name: "author",
            type: "text",
            label: "Author",
            defaultValue: "",
            placeholder: "Author",
            validationRules: {
                validate: {
                    atLeastOne: (v: string) => v.trim().length > 0 || "Author field can not be empty",
                    maxLength: (v: string) => v.trim().length <= 1200 || "Author field cannot exceed 1200 characters",
                }
            }
        },
        {
            name: "pages",
            type: "text",
            label: "Pages",
            defaultValue: "",
        },
        {
            name: "keywords",
            type: "text",
            label: "Keywords",
            defaultValue: "",
            validationRules: {
                validate: {
                    atLeastOne: (v: string) => v.trim().length > 0 || "Provide at least one keyword",
                    maxLength: (v: string) => v.trim().length <= 255 || "Keywords field cannot exceed 255 characters",
                }
            }
        },
        {
            name: "confirmAutofillCorrectness",
            type: "checkbox",
            label: "Have you confirmed that all of the above [AUTO FILL] information is complete and accurate?",
            required: true,
            validationRules: {
                validate: {
                    isYes: (v: string[]) => v.find((x) => x === "yes") != undefined || "Please confirm the correctness of the autofilled information.",
                }
            },
            options: [
                { label: "Yes", value: "yes" }
            ]
        },
        {
            name: "study",
            type: "checkbox",
            label: "Please select the type of registration (Check all that apply)",
            numColumns: 2,
            required: true,
            validationRules: {
                validate: {
                    atLeastOne: (v: string[]) => v.length > 0 || "Select at least one type of registration."
                }
            },
            options: [
                { label: "ABCD", value: "abcd" },
                { label: "HBCD", value: "hbcd" },
            ]
        }
    ]
};
